var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7368 17.5H15.9211C16.7931 17.5 17.5 16.7931 17.5 15.9211V13.1579M10 17.5H4.07895C3.20692 17.5 2.5 16.7931 2.5 15.9211V9.60526M2.5 9.60526V4.07895C2.5 3.20692 3.20642 2.5 4.07844 2.5H11.6234M2.5 9.60526H7.23684M7.23684 9.60526V6.05263M7.23684 9.60526V13.1579M11.6234 2.5H15.9213C16.7933 2.5 17.5 3.20692 17.5 4.07895V13.1579M11.6234 2.5V5.26316C11.6234 6.13519 12.3303 6.84211 13.2023 6.84211H14.7368M17.5 13.1579H11.6234",
    stroke: "#181C32",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWardIcon);
export default __webpack_public_path__ + "static/media/ward-icon.5f8ded0ea17756dda5689c9abe1c5d55.svg";
export { ForwardRef as ReactComponent };